module.exports = __webpack_public_path__ + "instagram-gallery-shadow.640338d8decee6b12ac3c267efa17f00.svg";